import { useContext } from 'react';

import CookieConsentContext, {
  CookieConsentContextValues
} from '@smart-tv/contexts/cookie-consent-context/cookie-consent-context';

export const useCookieConsent = (): CookieConsentContextValues => {
  const values = useContext(CookieConsentContext);

  return { ...values };
};

export default useCookieConsent;
